export default "__VITE_ASSET__B$X1TtUj__"